import React from 'react';
export function FooterSection() {
  return <footer className="bg-plum-900 text-white pt-20 pb-10 border-t-4 border-wine-600" data-id="element-93">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-94">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-gold-400 mb-6" data-id="element-95">
          💃 DANZA INFANTIL 360 — El sistema de planificación N°1 para
          profesoras de danza infantil argentinas.
        </h2>

        <p className="font-handwriting text-3xl md:text-4xl text-cream-100 mb-16 opacity-90" data-id="element-96">
          "Porque preparar una buena clase no debería costarte todas las noches
          de la semana."
        </p>

        <div className="border-t border-plum-800 pt-10" data-id="element-97">
          <p className="font-bold text-xl tracking-widest mb-6 text-cream-50" data-id="element-98">
            💃 DANZA INFANTIL 360™
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-plum-300 text-sm mb-10" data-id="element-99">
            <span data-id="element-100">📧 contacto@danzainfantil360.com.ar</span>
            <span className="hidden md:inline" data-id="element-101">|</span>
            <span data-id="element-102">📲 @danzainfantil360.ar</span>
            <span className="hidden md:inline" data-id="element-103">|</span>
            <span data-id="element-104">🌐 www.danzainfantil360.ar</span>
          </div>

          <p className="text-xs text-plum-400" data-id="element-105">
            © DANZA INFANTIL 360™ 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}